export enum Role {
    Admin,
    DealerAdmin,
    Advisor
}